import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import {
  Collapse,
  List,
  ListItemButton,
  ListItemIcon,
  ListItemText,
} from "@mui/material";
import { Fragment, useMemo, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useDrawerStore } from "../../../hooks/useDrawerStore";
import {
  ListItemButtonStyle,
  ListItemIconStyle,
  ListMainItemButtonStyle,
} from "../../../styles/components/NavSection.styles";
import { LocalStorageKey, RoutesMap } from "../../../types";
import {
  readLocalStorage,
  saveLocalStorage,
} from "../../../toolbox/helpers/local-storage-helpers";
import { navSections } from "../../../toolbox/constants/NavSection";
import ScrollBar from "../Scrollbar/Scrollbar";
import { useAuthStore } from "../../../hooks";
import { Role } from "../../../types/roles/roleTypes";

const agentViews = [
  RoutesMap.REWARDS,
  RoutesMap.REWARDSTUDENT,
  RoutesMap.REWARDSTUDENTDETAIL,
];
const adminRoutes = navSections.Admin;

export const NavSection = () => {
  //Hooks
  const { openDrawer } = useDrawerStore();
  const { user } = useAuthStore();
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const initialRuta = readLocalStorage(LocalStorageKey.RUTA);
  const [ruta, setRuta] = useState(initialRuta || "");

  const filteredRoutes = useMemo(() => {
    if (user.userType === Role.ADMIN) {
      return adminRoutes;
    }

    const tempRoutes = [...adminRoutes];

    return tempRoutes.filter(({ rutas, location }, index) => {
      if (user.userType === Role.AGENT) {
        if (rutas && rutas.length > 0) {
          const tmpRutas = rutas.filter(({ location }) => {
            return agentViews.includes(location);
          });

          if (tmpRutas.length > 0) {
            tempRoutes[index].rutas = tmpRutas;
            return true;
          }
          return false;
        }

        return location ? agentViews.includes(location) : false;
      }

      return true;
    });
  }, [user]);

  const isModule = (value: any): value is any => {
    return (value as any).name !== undefined;
  };
  const handleOnClick = (value: any) => {
    if (isModule(value)) {
      if (ruta === value.name) {
        setRuta("");
      } else {
        saveLocalStorage(LocalStorageKey.RUTA, value.name);
        setRuta(value.name);
      }
    } else {
      openDrawer(false);
      //   navigate({ pathname: value.location })
    }
  };

  const handleItemSelected = (pathname: any) => {
    openDrawer(false);
    navigate({ pathname: pathname });
  };

  return (
    <ScrollBar
      sx={{
        height: 1,
        "& .simplebar-content": {
          height: 1,
          display: "flex",
          flexDirection: "column",
        },
      }}
    >
      <List disablePadding sx={{ p: 1 }}>
        {!!(filteredRoutes.length > 0) &&
          filteredRoutes.map((route, index) => {
            // if (route?.type_module === 1) { return }
            const hasActiveChild = route.rutas?.some(
              (view) => pathname === view.location
            );
            const isItemSelected = ruta === route.name || hasActiveChild;
            const isDirectRouteSelected =
              !route.rutas && pathname === route.location;
            const IconModule = route.icon;
            return (
              <Fragment key={index}>
                {!route.rutas && (
                  <ListItemButton
                    onClick={() => handleItemSelected(route.location)}
                    key={index}
                    sx={{
                      mx: 1,
                      mb: 0.5,
                      minHeight: 46,
                      borderRadius: 2,
                      color: "text.secondary",
                      fontSize: 13,
                      transition: "background-color 160ms ease, color 160ms ease",
                      "&:hover": {
                        color: "primary.dark",
                        bgcolor: "rgba(1, 77, 223, 0.05)",
                      },
                      ...(isDirectRouteSelected
                        ? {
                            color: "primary.dark",
                            bgcolor: "primary.light",
                            fontWeight: 600,
                            "& .MuiListItemIcon-root": {
                              color: "primary.main",
                            },
                          }
                        : null),
                    }}
                  >
                    <ListItemIcon sx={ListItemIconStyle}>
                      {IconModule != null ? IconModule : null}
                    </ListItemIcon>
                    <ListItemText disableTypography primary={route.name} />
                  </ListItemButton>
                )}
                {route.rutas && (
                  <>
                    <ListItemButton
                      sx={{
                        mx: 1,
                        mb: 0.5,
                        minHeight: 46,
                        borderRadius: 2,
                        color: "text.secondary",
                        fontSize: 14,
                        "&:hover": {
                          color: "primary.dark",
                          bgcolor: "rgba(1, 77, 223, 0.05)",
                        },
                        ...(isItemSelected
                          ? {
                              color: "primary.dark",
                              bgcolor: "primary.light",
                              fontWeight: 600,
                              "& .MuiListItemIcon-root": {
                                color: "primary.main",
                              },
                            }
                          : null),
                        ...ListMainItemButtonStyle,
                      }}
                      onClick={() => handleOnClick(route)}
                    >
                      <ListItemIcon sx={ListItemIconStyle}>
                        {IconModule != null ? IconModule : null}
                      </ListItemIcon>
                      <ListItemText disableTypography primary={route.name} />
                      {isItemSelected ? (
                        <KeyboardArrowUpIcon />
                      ) : (
                        <KeyboardArrowDownIcon />
                      )}
                    </ListItemButton>
                    {
                      <Collapse
                        in={isItemSelected}
                        timeout="auto"
                        unmountOnExit
                      >
                        {route.rutas.map((view, index) => {
                          // if (view?.type === 1) {return}
                          const isSubRouteSelected = pathname === view.location;
                          const Icon = view.icon;
                          return (
                            <ListItemButton
                              onClick={() => handleItemSelected(view.location)}
                              key={index}
                              sx={{
                                ...ListItemButtonStyle,
                                mx: 1,
                                mb: 0.5,
                                minHeight: 40,
                                pl: 5,
                                borderRadius: 2,
                                color: "text.secondary",
                                fontSize: 13,
                                "&:hover": {
                                  color: "primary.dark",
                                  bgcolor: "rgba(1, 77, 223, 0.05)",
                                },
                                ...(isSubRouteSelected
                                  ? {
                                      color: "primary.dark",
                                      bgcolor: "primary.light",
                                      fontWeight: 600,
                                      "& .MuiListItemIcon-root": {
                                        color: "primary.main",
                                      },
                                    }
                                  : null),
                              }}
                            >
                              <ListItemIcon sx={ListItemIconStyle}>
                                {Icon != null ? Icon : null}
                              </ListItemIcon>
                              <ListItemText
                                disableTypography
                                primary={view.name_ruta}
                              />
                            </ListItemButton>
                          );
                        })}
                      </Collapse>
                    }
                  </>
                )}
              </Fragment>
            );
          })}
      </List>
    </ScrollBar>
  );
};
